export default "__VITE_ASSET__CZk$pSnd__"